import React from "react";
import {HEADER_LOGO} from "../../default_informations/header_logo";

function HeaderLogo({activeButton, toggleMenu}) {
    const headerLogo = HEADER_LOGO;

    return (
        <div className="logo col-auto">
            <button id="showMenu" className={activeButton ? "mobile-icon active" : "mobile-icon"} onClick={toggleMenu}>
                <span />
                <span />
                <span />
            </button>
            {
                window.location.pathname === '/' ? (
                    <span className="gg-header_logo">
                        <img
                            src={headerLogo.img}
                            alt={headerLogo.alt}
                        />
                    </span>
                ) : (
                    <a className="gg-header_logo" href="/">
                        <img
                            src={headerLogo.img}
                            alt={headerLogo.alt}
                        />
                    </a>
                )
            }
        </div>
    )
}

export default HeaderLogo;